import { PART_ICON_IDS, PartIcon, type PartIconId } from '@/icons/parts';

const ICON_LABELS: Record<PartIconId, string> = {
  'i-piston': 'Piston',
  'i-block': 'Block',
  'i-head': 'Head',
  'i-intake': 'Intake',
  'i-cover': 'Valve Cover',
  'i-rod': 'Conn Rod',
  'i-crank': 'Crank',
  'i-fender': 'Fender',
  'i-hood': 'Hood',
  'i-trunk': 'Trunk',
  'i-carb': 'Carb',
  'i-cam': 'Cam',
  'i-exhaust': 'Exhaust',
  'i-interior': 'Interior',
  'i-wing': 'Wing',
  'i-fastener': 'Fastener',
};

interface IconPickerProps {
  value: PartIconId;
  onChange: (iconId: PartIconId) => void;
}

export default function IconPicker({ value, onChange }: IconPickerProps) {
  return (
    <div className="icon-picker">
      {PART_ICON_IDS.map((iid) => {
        const active = value === iid;
        return (
          <button
            type="button"
            key={iid}
            className={`icon-picker-swatch${active ? ' active' : ''}`}
            onClick={() => onChange(iid)}
            aria-label={ICON_LABELS[iid]}
            aria-pressed={active}
            title={ICON_LABELS[iid]}
          >
            <PartIcon iconId={iid} size={32} />
            <span className="icon-picker-label">{ICON_LABELS[iid]}</span>
          </button>
        );
      })}
    </div>
  );
}
